import React, {useEffect} from 'react';

import { useAppSelector } from '../hooks/appHooks';
import { useDeviceWidth } from '../hooks/useDeviceWidth';
import { PRODUCTS } from '../lib/constants/appConstants';
import { getSelectedPackages } from '../store/slices/offerSlice';
import { DiscountSection } from '../components/Summary/DiscountSection';
import { SelectionSummary } from '../components/Summary/SelectionSummary';
import { Coupon, TotalPriceInfo } from '../interfaces/Types';
import { AppConstants } from '../utils/AppConstants';
import {
  discountResolver,
  discountResolverWithCouponCode,
  calculateFinalYearlyDiscount
} from '../utils/Calculation/CalculationService';
import { InsuranceHelper } from '../utils/InsuranceHelper';
import { DiscountHelper } from '../utils/DiscountHelper';

interface SummaryContainerProps {
  productName: string;
}
export const SummaryContainer: React.FC<SummaryContainerProps> = (
  props: SummaryContainerProps
) => {
  const { isLargeScreen } = useDeviceWidth();
  const isExpandCollapseEnabled =
    !isLargeScreen || props.productName === PRODUCTS.VILLA;
  const selectedPackages = useAppSelector(getSelectedPackages);
  const offerInfo = useAppSelector((state) => state.insurance.offer);
  const questionsInfo = useAppSelector(
    (state) => state.insurance.pricingQuestions
  );
  const additionalQuestionsInfo = useAppSelector(
    (state) => state.insurance.additionalInputs
  );
  const totalPriceInfo: TotalPriceInfo =
    InsuranceHelper.getTotalPriceInfoFromSelection(
      selectedPackages,
      offerInfo.productName
    );
  const { 
    couponCode = offerInfo.coupon?.couponCode, 
    couponDiscountPercentage = offerInfo.coupon?.couponDiscountPercentage 
  } = InsuranceHelper.retrievePolicyInfoFromURL();
  const couponInfo = {
    couponCode,
    couponDiscountPercentage
  };
  const selectionSummary = InsuranceHelper.getSummaryDetails(
    props.productName,
    questionsInfo,
    offerInfo,
    totalPriceInfo,
    selectedPackages,
    additionalQuestionsInfo
  );
  const discountDetails = DiscountHelper.buildDiscountDetails(
    props.productName,
    offerInfo.channel,
    offerInfo.discountPercentage,
    couponInfo
  );
  const discountsList = discountDetails.map(discount => parseInt(discount.value));
  const totalYearlyDiscount = calculateFinalYearlyDiscount( totalPriceInfo.totalPrice, discountsList) || 0;

  const totalPriceDetails = {
    label: AppConstants.getAppText('webshop.discount.total.label'),
    value: totalYearlyDiscount
          ? `${totalYearlyDiscount.toLocaleString('sv-SE')} ${
              totalPriceInfo.currency
            }${AppConstants.getAppText('webshop.summary.price.yearlyUnit')}`
          : '0 kr/år'
  };
  return (
    <>
      <div className="summary-container-wrapper">
        <SelectionSummary
          selections={selectionSummary}
          isExpandCollapseEnabled={isExpandCollapseEnabled}
        />
        <DiscountSection 
          discountsList={discountDetails} 
          totalYearlyDiscount={totalPriceDetails}
        />
      </div>
    </>
  );
};
